import React, { useEffect, useRef, useState } from "react";
import { useMediaQuery } from "react-responsive";

import "swiper/css";
import "swiper/css/navigation";
import { Swiper, SwiperSlide } from "swiper/react";
import { image } from "src/theme";

import { CommonDescFive } from "@assets/styles/CommonStyles";
import { commonSwiperOptions } from "@components/layout/CommonSwiperSettings";
import { useGetHomeSlideModal } from "@utils/api-requests/GlobalRequests";
import {
  CloseText,
  HideTodayText,
} from "@utils/lanugauge-settings/static-texts/TranslatedTexts";
import { LOCAL_MAIN_POPUP_EXPIRY } from "@utils/api-requests/static-data";
import { ErrorManage } from "@screens/index";

import {
  DailySlideImageContainer,
  DailySlideModalBottom,
  DailySlideModalContainer,
  DailySlideModalCount,
  DailySlideModalImage,
  DailySlideModalNavIcon,
  DailySlideModalOverlay,
} from "./ModalStyling";

const DailySlideModal = () => {
  const swiperRef = useRef(null);

  const [isVisible, setIsVisible] = useState(false);
  const [activeIndex, setActiveIndex] = useState(0);

  const isMobile = useMediaQuery({ maxWidth: 767 });

  const {
    data: homeSlideModal,
    isLoading,
    isError,
    error,
  } = useGetHomeSlideModal();

  const isBottom = homeSlideModal?.field_mobile_size_type !== "center"; // figma 2 types

  const handleSlideNav = (direction) => {
    if (swiperRef.current && swiperRef.current.swiper) {
      direction === "prev"
        ? swiperRef.current.swiper.slidePrev()
        : swiperRef.current.swiper.slideNext();
    }
  };

  const hidePopupForToday = () => {
    const midnight = new Date();
    midnight.setDate(midnight.getDate() + 1);
    midnight.setHours(0, 0, 0, 0);

    localStorage.setItem(
      LOCAL_MAIN_POPUP_EXPIRY,
      midnight.getTime().toString()
    );
  };

  const shouldShowPopup = () => {
    const expiryTime = localStorage.getItem(LOCAL_MAIN_POPUP_EXPIRY);

    if (!expiryTime) return true;

    const now = new Date().getTime();
    return now >= parseInt(expiryTime); // 현재 시간이 만료 시간 이후면 보여주기
  };

  const handleHidePopup = () => {
    hidePopupForToday();
    setIsVisible(false);
  };

  const handleOverlayClick = (e) => {
    if (e.target === e.currentTarget) {
      setIsVisible(false);
    }
  };

  useEffect(() => {
    // 컴포넌트 마운트 시 팝업 표시 여부 체크
    setIsVisible(shouldShowPopup());
  }, []);

  if (!isVisible) return null;

  return (
    !isLoading &&
    homeSlideModal.length > 0 && (
      <DailySlideModalOverlay onClick={handleOverlayClick}>
        <DailySlideModalContainer isMobile={isMobile} isBottom={isBottom}>
          <DailySlideImageContainer>
            <Swiper
              {...commonSwiperOptions}
              ref={swiperRef}
              onSlideChange={(swiper) => setActiveIndex(swiper.realIndex)}
              style={{ height: "100%" }}
            >
              <ErrorManage
                isLoading={isLoading}
                isError={isError}
                error={error}
              >
                {(homeSlideModal || []).map((item, index) => (
                  <SwiperSlide
                    style={{ height: "100%" }}
                    key={index}
                    onClick={() =>
                      window.open(item.field_thumbnail_link, "_blank")
                    }
                  >
                    <DailySlideModalImage
                      loading="eager"
                      src={
                        isMobile
                          ? item.field_image[0].src
                          : item.field_thumbnail[0].src
                      }
                      alt={
                        isMobile
                          ? item.field_image[0].alt
                          : item.field_thumbnail[0].alt
                      }
                    />
                  </SwiperSlide>
                ))}
              </ErrorManage>
            </Swiper>

            {homeSlideModal?.length > 1 && (
              <>
                <DailySlideModalNavIcon
                  direction="prev"
                  src={image.chevronLeft.default}
                  onClick={() => handleSlideNav("prev")}
                  draggable={false}
                />

                <DailySlideModalNavIcon
                  direction="next"
                  src={image.chevronRight.default}
                  onClick={() => handleSlideNav("next")}
                  draggable={false}
                />
              </>
            )}

            <DailySlideModalCount>
              <span>{(activeIndex || 0) + 1}</span>
              {` / ${homeSlideModal?.length}`}
            </DailySlideModalCount>
          </DailySlideImageContainer>

          <DailySlideModalBottom>
            <CommonDescFive onClick={handleHidePopup}>
              <HideTodayText />
            </CommonDescFive>

            <CommonDescFive onClick={() => setIsVisible(false)}>
              <CloseText />
            </CommonDescFive>
          </DailySlideModalBottom>
        </DailySlideModalContainer>
      </DailySlideModalOverlay>
    )
  );
};

export default DailySlideModal;
